// Mock data for JBM website - All data is editable

export const contactInfo = {
  phone: "+91 9871008196, 7678364279",
  whatsapp: "+91 9871008196",
  email: "jyotibagmanufacturer@gmail.com",
  address:
    "Khasra No. 227 Garhi-Guldhar Merrut Road Near Vardan Hospital , Ghaziabad (U.P) - 201003, India",
  businessHours: "Mon - Sat: 9:00 AM - 6:00 PM",
  gstNumber: "09BEEPT3981C1Z9",
  udyamNumber: "UDYAM-UP-29-0092212",
  yearsInBusiness: "10+",
};

export const products = [
  {
    id: 1,
    name: "PVC Zipper Pillow Bags",
    category: "Pvc Bag, Non-Woven bags",
    material: "PVC clear , Non-Woven cloth",
    sizeOptions: ["Custom Size"],
    image: "/images/yellow pillow(black) front.jpg",
    description: "Durable PVC zipper bags for Pillow packaging",
  },
  {
    id: 2,
    name: "Comftor bags",
    category: "PVC Bags",
    material: "PVC clear",
    sizeOptions: ["16x21 inch", "18x23 inch", "Custom Size"],
    image: "/images/comftor bag 3.jpg",
    description: "Comftor packaging bags for quick packaging",
  },
  {
    id: 3,
    name: "PVC neck pillow bag",
    category: "PVC Bags",
    material: "PVC , Non-Woven",
    sizeOptions: ["Custom Size"],
    image: "/images/neck pillow bag.jpg",
    description: "Premium bags with button closure and hanger options",
  },
  {
    id: 4,
    name: "Cushion Bags",
    category: "Non-Woven Bags",
    material: "Non-Woven Fabric",
    sizeOptions: ["Small", "Medium", "Large", "Extra Large", "Custom Size"],
    image: "/images/red pillow mahajan.jpg",
    description: "Eco-friendly non-woven bags for shopping and packaging",
  },
  {
    id: 5,
    name: "Mattress Cover Bags",
    category: "Home Textiles",
    material: "Plastic/PVC",
    sizeOptions: ["Single", "Double", "Queen", "King", "Custom Size"],
    image: "https://images.unsplash.com/photo-1688384452844-8364c3e2fc28",
    description: "Protective mattress covers for storage and transport",
  },
  {
    id: 6,
    name: "Pillow Bags",
    category: "Pvc Bag, Non-Woven bags",
    material: "Plastic/Non-Woven",
    sizeOptions: [
      "Standard Pillow",
      "King Pillow",
      "Single Dohar",
      "Double Dohar",
      "Custom Size",
    ],
    image: "images/yellow pillow(black) bag.jpg",
    description: "Quality packaging for pillows and comfort items",
  },
  {
    id: 7,
    name: "Blanket Bags",
    category: "Comftor Bags",
    material: "Plastic/PVC",
    sizeOptions: ["Single", "Double", "Custom Size"],
    image: "/images/white comftor.jpg",
    description: "Durable bags for blanket storage and packaging",
  },
  {
    id: 8,
    name: "Tar Bags",
    category: "Comftor Bags",
    material: "Heavy-duty Plastic",
    sizeOptions: ["Single", "Double", "Custom Size"],
    image: "/images/comftor bag.jpg",
    description: "Heavy-duty bags for tar and industrial materials",
  },
  {
    id: 9,
    name: "Dohar Packaging Bags",
    category: "PVC Bags",
    material: "Clear PVC",
    sizeOptions: ["Custom Size"],
    image: "/images/dohar bag.jpeg",
    description: "Transparent PVC bags for product visibility",
  },
  {
    id: 10,
    name: "Premium Pillow Bags",
    category: "Pvc Bag, Non-Woven bags",
    material: "Plastic/Non-Woven",
    sizeOptions: [
      "Standard Pillow",
      "King Pillow",
      "Single Dohar",
      "Double Dohar",
      "Custom Size",
    ],
    image: "/images/black mahagan pillow bag.jpg",
    description: "Quality packaging for pillows and comfort items",
  },
  {
    id: 11,
    name: "Non-Woven Bags",
    category: "Non-Woven bags",
    material: "Plastic/Non-Woven",
    sizeOptions: [
      "Custom Size",
    ],
    image: "/images/carry bag.jpeg",
    description: "Non-Woven Carry bag for multiple items",
  },
];

export const categories = [
  "All Products",
  "PVC Bags",
  "Non-Woven Bags",
  "Comftor bags",
  "Dohar Bags",
  "Pillow Bags",
  "Mattress Cover Bags",
];

export const whyChooseUs = [
  {
    title: "Direct Manufacturer",
    description: "Get the best prices by buying directly from the manufacturer",
    icon: "Factory",
  },
  {
    title: "Custom Printing Available",
    description: "Print your brand logo and design on bags",
    icon: "Palette",
  },
  {
    title: "Quality Materials",
    description: "Premium quality PVC and non-woven materials",
    icon: "Award",
  },
  {
    title: "Bulk Orders Supported",
    description: "We handle orders of all sizes with ease",
    icon: "Package",
  },
  {
    title: "All India Delivery",
    description: "Fast and reliable delivery across India",
    icon: "Truck",
  },
  {
    title: "Fast Turnaround",
    description: "Quick production and delivery timelines",
    icon: "Clock",
  },
];

export const customizationOptions = {
  bagTypes: [
    "PVC Zipper Bag",
    "Self-Adhesive Bag",
    "Non-Woven Bag",
    "Mattress Cover",
    "Pillow Bag",
    "Blanket Bag",
    "Tar Bag",
    "Custom Design",
  ],
  sizes: [
    "Small (6x8 inch)",
    "Medium (10x12 inch)",
    "Large (14x18 inch)",
    "Extra Large (18x24 inch)",
    "Custom Size",
  ],
  colors: [
    "Clear/Transparent",
    "White",
    "Red",
    "Blue",
    "Green",
    "Black",
    "Yellow",
    "Custom Color",
  ],
  quantities: [
    "100-500 pieces",
    "500-1000 pieces",
    "1000-5000 pieces",
    "5000+ pieces",
  ],
};
